module.exports = __webpack_public_path__ + "static/jimi-2c5cb452501e099d28a93e1d76b121c4.gif";